import React, { useState, useEffect, useRef } from "react";





const RefundPolicy = () => {
   

    return (
        <React.Fragment>
          <div className="RefundPolicy">
          <div className="container">
            <div className="refund_main_sec">
            <h3 className="refund_main_header">Refund Policy</h3>
            <p className="refund_main">At Finlabs Learning Hub, we are committed to providing high-quality educational content curated by industry experts. To ensure the integrity of our services and content, we maintain a strict no-refund policy once a course has been purchased. Please review the following guidelines carefully.</p>
            </div>

            <div className="refund_middle_sec">
                {/* <ol type="1">
                    <li></li>
                </ol> */}
                <h5 className="refund_header">1. No Refund Policy</h5>
                <p className="refund_detail">Once a course is purchased, it is non-refundable under any circumstances. This policy applies to all individual courses, subscriptions, and any customized solutions or group purchases made through our platform.</p>
                
                <h5 className="refund_header">2. Why We Don't Offer Refunds</h5>
                <p className="refund_detail">Immediate Access: Upon purchase, you gain instant access to all course materials. This allows you to benefit from the content immediately, making the course non-returnable.<br/>
                Digital Nature of the Product: As our courses are digital products, they cannot be “returned” in the traditional sense. Access to content makes the purchase final.</p>

                <h5 className="refund_header">3. Course Information</h5>
                <p className="refund_detail">To assist in making informed decisions before purchasing:<br/>
                Course Descriptions: Detailed descriptions and course outlines are provided on each course page so you can review the content before making a purchase.</p>

                <h5 className="refund_header">4. Technical Support</h5>
                <p className="refund_detail">If you experience technical issues that prevent you from accessing the course materials:
                <br/>
                Contact Support: Our technical support team is available to help resolve any access issues. If you encounter difficulties, please contact us at <a href="mailto: info@finlabsindia.com"><i>info@finlabsindia.com</i></a>  We are committed to ensuring a smooth and enjoyable learning experience.</p>

                <h5 className="refund_header">5. Course Changes or Cancellations</h5>
                <p className="refund_detail">In rare cases where Finlabs Learning Hub cancels or significantly alters a course after purchase, we will notify affected users. In such cases, we may offer alternative courses or access to updated content.</p>

                <h5 className="refund_header">6. For Organizations</h5>
                <p className="refund_detail">Refunds for group or bulk purchases are not available. Organizations purchasing courses for their teams are encouraged to review the content description thoroughly before purchase. Custom training solutions and bulk pricing are non-refundable.</p>
            </div>

            <div className="refund_below_sec">
            <p className="refund_below"><b>Contact Us:</b> If you have any questions or need further clarification regarding this policy, please reach out to our support team at <a href="mailto: info@finlabsindia.com"><i>info@finlabsindia.com</i></a></p>
            
            <p className="refund_below">We value your commitment to learning and are here to provide the best possible experience.</p>
            </div>

            
           </div>
          </div>
            
        </React.Fragment>
    )
}

export default RefundPolicy;